import React, { Dispatch, useState } from 'react';
import { t } from 'Locale/index';
import { LanguageSettingsContext, StyleMap } from 'types';
import { IAudioTrack, ITextTrack } from '@24i/player-base';
import { PlayerManager } from '@24i/react-native-player';
import { useLanguageSettingsContext } from 'LocalGluons';
import MediaTrackSelectBox from '../MediaTrackSelectBox/MediaTrackSelectBox';
import defaultStyles from './styles';
import { getTrackLabel } from '../GetTrackLabel';

interface AudioModalProps {
    style: StyleMap;
    onClose: () => void;
    audioTracks: IAudioTrack[];
    playerInstance: PlayerManager;
    setSelectedAudioTrack: Dispatch<IAudioTrack>;
    selectedAudioTrack: IAudioTrack;
}

const AudioModal = ({
    style,
    onClose,
    audioTracks: playerAudioTracks,
    selectedAudioTrack,
    playerInstance,
    setSelectedAudioTrack
}: AudioModalProps) => {
    const {
        setSelectedPlayerAudioId,
        getAudioTrackLabel
    } = useLanguageSettingsContext() as LanguageSettingsContext;

    const parseAudioTracks = (unparsedTracks: IAudioTrack[]) => {
        const tracks = unparsedTracks || [];
        return tracks.map((audioTrack) => ({
            ...audioTrack,
            isSelected: audioTrack.selected,
            language: getTrackLabel(audioTrack)
        }));
    };

    const parsedAudioTracks = parseAudioTracks(playerAudioTracks);
    const [audioTracks, setAudioTracksParsed] = useState([...parsedAudioTracks]);

    const onSelectAudioTrack = (item: IAudioTrack) => {
        const newAudioTracks = audioTracks.map(audioTrack => ({
            ...audioTrack,
            selected: audioTrack.id === item.id ?
                !!setSelectedPlayerAudioId(audioTrack.id) : false,
        }));
        playerInstance.audioTrack = item;
        setSelectedAudioTrack(item);
        setAudioTracksParsed(newAudioTracks);
        onClose();
    };
    const selectedAudioTracks = audioTracks.map(audioTrack =>
    ({
        ...audioTrack,
        isSelected: audioTrack.id === selectedAudioTrack.id,
        language: getAudioTrackLabel(audioTrack)
    })
    );

    return (
        <MediaTrackSelectBox
            title={t('COMMON.AUDIO')}
            defaultStyles={defaultStyles}
            style={style}
            onSelectMediaTrack={onSelectAudioTrack as (item: IAudioTrack | ITextTrack) => void}
            selectedMediaTracks={selectedAudioTracks}
            onClose={onClose}
        />
    );
};

export default AudioModal;
